webpackJsonp([42],{

/***/ 1066:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_manage_category_js__ = __webpack_require__(1178);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273f99b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manage_category_vue__ = __webpack_require__(1289);
function injectStyle (ssrContext) {
  __webpack_require__(1287)
}
var normalizeComponent = __webpack_require__(193)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_manage_category_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_273f99b5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_manage_category_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var residences = [{
  value: 'zhejiang',
  label: 'Zhejiang',
  children: [{
    value: 'hangzhou',
    label: 'Hangzhou',
    children: [{
      value: 'xihu',
      label: 'West Lake'
    }]
  }]
}, {
  value: 'jiangsu',
  label: 'Jiangsu',
  children: [{
    value: 'nanjing',
    label: 'Nanjing',
    children: [{
      value: 'zhonghuamen',
      label: 'Zhong Hua Men'
    }]
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      previewVisible: false,
      previewImage: '',
      fileList: [{
        uid: '-1',
        name: 'xxx.png',
        status: 'done',
        url: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png'
      }],
      confirmDirty: false,
      residences: residences,
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 }
        }
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0
          },
          sm: {
            span: 16,
            offset: 8
          }
        }
      }
    };
  },
  beforeCreate: function beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'register' });
  },

  methods: {
    testdata: function testdata() {
      console.log(this.password);
    },
    handleCancel: function handleCancel() {
      this.previewVisible = false;
    },
    handlePreview: function handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange: function handleChange(_ref) {
      var fileList = _ref.fileList;

      this.fileList = fileList;
    },
    handleSubmit: function handleSubmit(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll(function (err, values) {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    handleConfirmBlur: function handleConfirmBlur(e) {
      var value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword: function compareToFirstPassword(rule, value, callback) {
      var form = this.form;
      if (value && value !== form.getFieldValue('password')) {
        // eslint-disable-next-line standard/no-callback-literal
        callback('รหัสผ่านไม่ตรงกัน');
      } else {
        callback();
      }
    },
    validateToNextPassword: function validateToNextPassword(rule, value, callback) {
      var form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(['confirm'], { force: true });
      }
      callback();
    },
    handleWebsiteChange: function handleWebsiteChange(value) {
      var autoCompleteResult = void 0;
      if (!value) {
        autoCompleteResult = [];
      } else {
        autoCompleteResult = ['.com', '.org', '.net'].map(function (domain) {
          return '' + value + domain;
        });
      }
      this.autoCompleteResult = autoCompleteResult;
    }
  }
});

/***/ }),

/***/ 1287:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1288);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("5ef645e0", content, true, {});

/***/ }),

/***/ 1288:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".ant-upload-select-picture-card i{font-size:100px;color:#999}.ant-upload-select-picture-card .ant-upload-text{margin-top:8px;color:#666}.ant-upload-list-picture-card .ant-upload-list-item{float:left;width:250px;height:250px;margin:0 8px 8px 0}.ant-upload.ant-upload-select-picture-card{display:table;width:250px;height:250px;margin-right:8px;margin-bottom:8px;text-align:center;vertical-align:top;background-color:#fafafa;border:1px dashed #d9d9d9;border-radius:4px;cursor:pointer;-webkit-transition:border-color .3s ease;transition:border-color .3s ease}.ant-form-item{-webkit-box-sizing:border-box;box-sizing:border-box;margin:0;padding:0;color:rgba(0,0,0,.65);font-size:14px;font-variant:tabular-nums;line-height:1.5;list-style:none;-webkit-font-feature-settings:\"tnum\";font-feature-settings:\"tnum\";margin-bottom:0;vertical-align:top}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/views/manage_category.vue"],"names":[],"mappings":"AA8FA,kCACE,gBAAiB,AACjB,UAAY,CACb,AACD,iDACE,eAAgB,AAChB,UAAY,CACb,AACD,oDACE,WAAY,AACZ,YAAa,AACb,aAAc,AACd,kBAAoB,CACrB,AACD,2CACE,cAAe,AACf,YAAa,AACb,aAAc,AACd,iBAAkB,AAClB,kBAAmB,AACnB,kBAAmB,AACnB,mBAAoB,AACpB,yBAA0B,AAC1B,0BAA2B,AAC3B,kBAAmB,AACnB,eAAgB,AAChB,yCAA2C,AAC3C,gCAAmC,CACpC,AACD,eACE,8BAA+B,AACvB,sBAAuB,AAC/B,SAAU,AACV,UAAW,AACX,sBAA2B,AAC3B,eAAgB,AAChB,0BAA2B,AAC3B,gBAAiB,AACjB,gBAAiB,AACjB,qCAAsC,AAC9B,6BAA8B,AACtC,gBAAmB,AACnB,kBAAoB,CACrB","file":"manage_category.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* you can make up upload button and sample style by using stylesheets */\n.ant-upload-select-picture-card i {\n  font-size: 100px;\n  color: #999;\n}\n.ant-upload-select-picture-card .ant-upload-text {\n  margin-top: 8px;\n  color: #666;\n}\n.ant-upload-list-picture-card .ant-upload-list-item {\n  float: left;\n  width: 250px;\n  height: 250px;\n  margin: 0 8px 8px 0;\n}\n.ant-upload.ant-upload-select-picture-card {\n  display: table;\n  width: 250px;\n  height: 250px;\n  margin-right: 8px;\n  margin-bottom: 8px;\n  text-align: center;\n  vertical-align: top;\n  background-color: #fafafa;\n  border: 1px dashed #d9d9d9;\n  border-radius: 4px;\n  cursor: pointer;\n  -webkit-transition: border-color 0.3s ease;\n  transition: border-color 0.3s ease;\n}\n.ant-form-item {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5;\n  list-style: none;\n  -webkit-font-feature-settings: 'tnum';\n          font-feature-settings: 'tnum';\n  margin-bottom: 0px;\n  vertical-align: top;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1289:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card mt-3",style:({ 'min-height' : _vm.$store.state.screenHeight - 100 + 'px' })},[_c('div',{staticClass:"card-body text-left"},[_c('div',{staticClass:"row",staticStyle:{"background-color":"#FF6161","display":"flex","justify-content":"left","align-items":"center"}},[_c('a-icon',{staticStyle:{"margin-right":"6px","font-size":"40px"},attrs:{"type":"user"}}),_vm._v(" "),_c('h1',{staticStyle:{"font-weight":"bold","margin":"5px"}},[_vm._v("เพิ่มหมวดหมู่สินค้า")])],1),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"background-color":"#ffffff"}},[_c('a-col',{staticStyle:{"background-color":"#ffffff","padding":"10px"},attrs:{"span":24}},[_c('a-form',{attrs:{"form":_vm.form},on:{"submit":_vm.handleSubmit}},[_c('a-form-item',_vm._b({},'a-form-item',_vm.formItemLayout,false),[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n              ชื่อหมวดหมู่\n            ")]),_vm._v(" "),_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
                'name',
                {
                  rules: [{ required: true, message: 'กรุณากรอกชื่อหมวดหมู่', whitespace: true }],
                } ]),expression:"[\n                'name',\n                {\n                  rules: [{ required: true, message: 'กรุณากรอกชื่อหมวดหมู่', whitespace: true }],\n                },\n              ]"}]})],1),_vm._v(" "),_c('a-form-item',_vm._b({attrs:{"label":"ชื่อย่อ"}},'a-form-item',_vm.formItemLayout,false),[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
                'shot_name',
                {
                  rules: [{ required: true, message: 'กรุณากรอกชื่อย่อ', whitespace: true }],
                } ]),expression:"[\n                'shot_name',\n                {\n                  rules: [{ required: true, message: 'กรุณากรอกชื่อย่อ', whitespace: true }],\n                },\n              ]"}]})],1),_vm._v(" "),_c('a-form-item',_vm._b({attrs:{"label":"Phone Number"}},'a-form-item',_vm.formItemLayout,false),[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
                'phone',
                {
                  rules: [{ required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' }],
                } ]),expression:"[\n                'phone',\n                {\n                  rules: [{ required: true, message: 'กรุณากรอกเบอร์โทรศัพท์' }],\n                },\n              ]"}],staticStyle:{"width":"100%"}},[_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:(['prefix', { initialValue: '86' }]),expression:"['prefix', { initialValue: '86' }]"}],staticStyle:{"width":"70px"},attrs:{"slot":"addonBefore"},slot:"addonBefore"},[_c('a-select-option',{attrs:{"value":"86"}},[_vm._v("\n                  +66\n                ")]),_vm._v(" "),_c('a-select-option',{attrs:{"value":"87"}},[_vm._v("\n                  +87\n                ")])],1)],1)],1),_vm._v(" "),_c('a-form-item',_vm._b({},'a-form-item',_vm.formItemLayout,false),[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("\n              ตำแหน่ง\n            ")]),_vm._v(" "),_c('a-select',{directives:[{name:"decorator",rawName:"v-decorator",value:([
                'role',
                { rules: [{ required: true, message: 'กรุณาเลือกตำแน่ง!' }] } ]),expression:"[\n                'role',\n                { rules: [{ required: true, message: 'กรุณาเลือกตำแน่ง!' }] },\n              ]"}]},[_c('a-select-option',{attrs:{"value":"admin"}},[_vm._v("\n                admin\n              ")]),_vm._v(" "),_c('a-select-option',{attrs:{"value":"member"}},[_vm._v("\n                member\n              ")])],1)],1),_vm._v(" "),_c('a-form-item',_vm._b({},'a-form-item',_vm.tailFormItemLayout,false),[_c('a-button',{attrs:{"type":"primary","html-type":"submit"}},[_vm._v("\n              บันทึก\n            ")])],1)],1)],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/42.e6dc623efe05706fc9ea.js